import en from './en';
import type { TranslationSchema } from './en';

const te: TranslationSchema = {
    ...en,
};

export default te;
